import React from 'react';
import PropTypes from 'prop-types';
import CustomScrollableList from './comp/customScrollableList/CustomScrollableList';
import { TARGET_FIELDS_PROP_TYPE } from 'shared/constants/PropTypes';

class RuleBuilder extends React.PureComponent {
  constructor(props){
    super(props);
    this.state = {
      ruleValue: props.startingValue
    };
  }

  handleItemClick = itemName => {
    this.setState(oldState => {
      const ruleValue = `${oldState.ruleValue}${itemName} `;
      this.props.onValueChange(ruleValue);
      return ({ ruleValue });
    });
  };

  handleTextAreaChange = ev => {
    this.props.onValueChange(ev.target.value);
    this.setState({ ruleValue: ev.target.value});
  };

  render() {
    const { leftItems, rightItems, surroundField, id } = this.props;
    return (
      <div id={ id } className="rule-builder">
        <div className="rule-builder_list-container">
          <CustomScrollableList id="rule-builder-left-list" className="rule-builder_list" items={ leftItems } onItemClick={ this.handleItemClick } surroundField={ surroundField } />
          <div className="rule-builder_spacer" />
          <div className="rule-builder_center-input">
            <textarea id="rule-builder-center-text-area" value={ this.state.ruleValue } onChange={ this.handleTextAreaChange } />
          </div>
          <div className="rule-builder_spacer" />
          <CustomScrollableList id="rule-builder-right-list" className="rule-builder_list" items={ rightItems } onItemClick={ this.handleItemClick } />
        </div>
      </div>
    );
  }
}

RuleBuilder.propTypes = {
  id: PropTypes.string,
  leftItems: TARGET_FIELDS_PROP_TYPE.isRequired,
  rightItems: TARGET_FIELDS_PROP_TYPE.isRequired,
  startingValue: PropTypes.string,
  onValueChange: PropTypes.func,
  surroundField: PropTypes.bool
};

RuleBuilder.defaultProps = {
  startingValue: '',
  onValueChange: () => null,
  surroundField: false
};

export default RuleBuilder;



// WEBPACK FOOTER //
// ./src/components/manageRules/comp/ruleEditor/comp/ruleBuilder/RuleBuilder.js